import Vue from 'vue'

Vue.component('ui-popup', require('./popup').default)
Vue.component('ui-overlay', require('./overlay').default)
Vue.component('ui-tooltip', require('./tooltip').default)
Vue.component('ui-circle-timer', require('./circle-timer').default)
Vue.component('ui-social', require('./social').default)
// Vue.component('UiSpinner', require('./spinner').default)
// Vue.component('UiSocial', require('./social').default)
// Vue.component('UiBurger', require('./burger').default)
